export default __webpack_public_path__ + "static/media/xianshi.c2fc7bd7.png";